import React, {useCallback, useMemo, useState} from 'react'
import styled from 'styled-components'
import {useHistory} from 'utils/commons'
import {Icon, Paragraph, Pressable, Menu, MenuItem} from 'common/components'
import {reduxResetDispatcher, useSelector} from 'lib/redux'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 64px;
  width: 100%;
  align-items: center;
  background-color: ${({theme}) => theme.white_1};
  gap: 16px;
`

const StyledSectionInfo = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledLogout = styled(Paragraph)`
  width: fit-content;
  margin-top: -4px;
`

export interface TemplateDropboxProfileProps {
  mode?: 'bar' | 'icon'
}

export default function TemplateDropboxProfile({
  mode = 'bar',
}: TemplateDropboxProfileProps) {
  const {creator} = useSelector('user')!
  const stateToggle = useState(false)
  const toggle = stateToggle[0]
  const history = useHistory()

  const creatorName = useMemo(() => `@${creator}`, [creator])

  const handleLogout = useCallback(() => {
    reduxResetDispatcher('user')
  }, [])

  const handleRenderMenuContent = useCallback(
    () => (
      <>
        {mode === 'icon' && <MenuItem title={creatorName} />}
        <MenuItem
          title="Upload Content"
          icon="upload"
          color="primary_5"
          fontWeight="bold"
          onClick={() => history.push('dropbox_upload', {})}
        />
        {/* <MenuItem
          title="My Creation"
          icon="image-alt"
          onClick={() => history.push('dropbox_creation', {})}
        /> */}
        {mode === 'icon' && (
          <MenuItem
            title="Close Dashboard"
            icon="logout"
            onClick={handleLogout}
          />
        )}
      </>
    ),
    [creatorName, history, mode, handleLogout],
  )

  const handleRenderBar = useCallback(
    () => (
      <StyledContainer>
        <Menu
          stateToggle={stateToggle}
          directionVertical="top"
          renderContent={handleRenderMenuContent}>
          <Icon type={toggle ? 'close' : 'menu'} size={28} />
        </Menu>
        <StyledSectionInfo>
          <Paragraph fontSize="l" fontWeight="bold">
            {creatorName}
          </Paragraph>
          <Pressable onClick={handleLogout}>
            <StyledLogout fontWeight="bold" color="primary_5">
              Close Dashboard
            </StyledLogout>
          </Pressable>
        </StyledSectionInfo>
      </StyledContainer>
    ),
    [creatorName, stateToggle, toggle, handleLogout, handleRenderMenuContent],
  )

  const handleRenderIcon = useCallback(
    () => (
      <Menu
        stateToggle={stateToggle}
        directionVertical="bottom"
        directionHorizontal="left"
        offset={8}
        renderContent={handleRenderMenuContent}>
        <Icon type={toggle ? 'close' : 'menu'} size={28} />
      </Menu>
    ),
    [toggle, stateToggle, handleRenderMenuContent],
  )

  return mode === 'bar' ? handleRenderBar() : handleRenderIcon()
}
